"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlaylistControls = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getProperty = require("../../util/getProperty");

var _PlaylistController = require("./controllers/PlaylistController");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var usePlaylistControls = function usePlaylistControls(ref) {
  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      rev = _useState2[0],
      setRev = _useState2[1];

  var controller = (ref === null || ref === void 0 ? void 0 : ref.current) > 0 ? _PlaylistController.PlaylistController.getInstance(ref.current) : null;

  var onPlaylistChanged = function onPlaylistChanged() {
    setRev(rev + 1);
  };

  (0, _react.useEffect)(function () {
    var id = (0, _getProperty.getProperty)("id", controller, -12);
    var key = "trc-playlist-changed-".concat(id);
    document.addEventListener(key, onPlaylistChanged);
    return function () {
      document.removeEventListener(key, onPlaylistChanged);
    };
  }, [ref === null || ref === void 0 ? void 0 : ref.current, rev]);

  var onItemChanged = function onItemChanged(handle) {
    controller.onItemChanged = handle;
  };

  var goToNext = function goToNext() {
    controller.goToNext();
    setRev(rev + 1);
  };

  var goToPrev = function goToPrev() {
    controller.goToPrev();
    setRev(rev + 1);
  };

  var goToItem = function goToItem(id) {
    var changed = controller.goToItem(id);
  };

  var goToNextTouch = function goToNextTouch(t) {
    controller.goToNextTouch(t);
    setRev(rev + 1);
  };

  var jump = function jump(to) {
    controller.jump(to);
  };

  var jumpAhead = function jumpAhead(amt) {
    controller.jumpAhead(amt);
  };

  var jumpBack = function jumpBack(amt) {
    controller.jumpBack(amt);
  };

  var getTouchesFromMoments = function getTouchesFromMoments(items) {
    controller.getTouchesFromMoments(items);
  };

  var value = {
    currentMoment: controller === null || controller === void 0 ? void 0 : controller.currentMoment,
    fluidSources: controller === null || controller === void 0 ? void 0 : controller.fluidSources,
    fluidSourcesInfo: {
      firstActiveFluidSource: controller.firstActiveFluidSource(),
      lastActiveFluidSource: controller.lastActiveFluidSource(),
      activeFluidSources: controller.activeFluidSources(),
      firstMainFluidSource: controller.firstMainFluidSource(),
      lastMainFluidSource: controller.lastMainFluidSource(),
      mainFluidSources: controller.mainFluidSources()
    },
    fluidSource: controller === null || controller === void 0 ? void 0 : controller.fluidSource,
    nextMoment: controller === null || controller === void 0 ? void 0 : controller.nextMoment,
    prevMoment: controller === null || controller === void 0 ? void 0 : controller.prevMoment,
    insideMoment: controller === null || controller === void 0 ? void 0 : controller.insideMoment,
    goToNext: goToNext,
    goToPrev: goToPrev,
    goToItem: goToItem,
    goToNextTouch: goToNextTouch,
    onItemChanged: onItemChanged,
    jump: jump,
    jumpAhead: jumpAhead,
    jumpBack: jumpBack,
    getTouchesFromMoments: getTouchesFromMoments,
    items: controller === null || controller === void 0 ? void 0 : controller.items,
    controller: controller,
    setItems: function setItems(items, initialId) {
      if (controller) {
        var change = controller.setItems(items, initialId);

        if (change) {
          setRev(rev + 1);
        }
      } else {
        throw "Cannot set items when playlist controller is null";
      }
    },
    setItemsAndSources: function setItemsAndSources(fluidSources, items, initialId) {
      if (controller) {
        var change = controller.setSourcesAndItems(fluidSources, items, initialId);

        if (change) {
          setRev(rev + 1);
        }
      } else {
        throw "Cannot set items and sources when playlist controller is null";
      }
    }
  };
  return value;
};

exports.usePlaylistControls = usePlaylistControls;